export default "__VITE_ASSET__BL_mKAGR__"